<script lang="ts">
    import { mdiChevronRight } from "@mdi/js"
    import { spaNavigate } from "../../actions"
    import { openSubmodule } from "./MobileMenu.svelte"
    import Icon from "../widgets/Icon.svelte"
    import { overlays } from "../../store"
    export let element: NavigationElement, darkBg: boolean
</script>

<ul
    class="subCategory"
    class:darkBg="{darkBg}"
>
    {#each element.elements as subCategory}
        <li>
            <button
                class="cta"
                on:click="{() => {
                    if (subCategory.elements?.length) openSubmodule(subCategory)
                    else {
                        $overlays = []
                        spaNavigate(subCategory.page)
                    }
                }}"
            >
                <p>{subCategory.name}</p>
                {#if subCategory.elements?.length}
                    <Icon path="{mdiChevronRight}" />
                {/if}
            </button>
        </li>
    {/each}
</ul>

<style lang="less">
    .subCategory {
        display: flex;
        flex-direction: column;
        gap: 12px;

        li {
            button {
                background-color: var(--bg-300);
                display: flex;
                width: 100%;
                justify-content: space-between;
                align-items: center;
            }
        }
        &.darkBg {
            background-color: transparent;
            button {
                background: var(--bg-200);
                color: var(--text-100);
                p {
                    color: var(--text-100);
                }
            }
        }
    }
</style>
